<script>
import { Swiper, Pagination } from 'swiper'
import 'swiper/swiper.min.css'
import 'swiper/modules/pagination/pagination.min.css'

export default {
  name: 'MySwiperComponent',
  emit: ['update-index'],
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    currentSelect: 0,
  }),
  mounted() {
    console.log(this.data);
    
    this.initSwiper()
  },
  methods: {
    clickTag(index, tag) {
      this.currentSelect = index
      this.$emit('click-index', tag)
      this.$gtag.event('category_click', {
        category_name: tag,
        category_code: index,
        page_section: '本月職人推薦'
      })
    },
    initSwiper() {
      new Swiper('.tag_swiper-container', {
        slidesPerView: 'auto',
        spaceBetween: 8,
        slidesOffsetBefore: 24,
        slidesOffsetAfter: 24,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        modules: [Pagination],
        on: {
          slideChange: el => {
            this.$emit('update-index', el.realIndex)
          },
        },
      })
    },
  },
}
</script>
<template>
  <div v-if="data.length >= 1" class="tag_swiper-container">
    <div class="swiper-wrapper">
      <div :class="{'active': currentSelect === index}" class="swiper-slide" v-for="(info, index) in data" :key="info.id" @click="clickTag(index,info.activity_category_name)">
        {{ info.activity_category_name }}
      </div>
    </div>
    <!-- <div class="swiper-pagination"></div> -->
  </div>
</template>

<style lang="scss" scoped>
.swiper-container {
  width: 100%;
  overflow-x: hidden;
  position: relative; /* 分頁指示器需要相對定位 */
}
.swiper-slide {
  font-family: Noto Sans TC;
  flex-shrink: 0;
  width: auto; /* 自動由 Swiper 控制寬度 */
  text-align: center;
  border-radius: 8px;
  border: solid 1px #FF7649;
  color: #FF7649;
  padding: 8px 12px;
  font-size: 11px;
  line-height: 1.2;
  font-weight: 500;
  background-color: #fff;
  &.active{
    background-color: #FF7649;
    color: #fff;
  }
}
:deep(.swiper-pagination) {
  position: absolute;
  bottom: 14px;
  left: 0;
  right: 0;
  text-align: center;
}

:deep(.swiper-pagination-bullet) {
  background-color: #909090;
  width: 4px;
  height: 4px;
  border-radius: 100%;
  transition: 0.3s;
  /* margin: 0px 6px !important; */
}

:deep(.swiper-pagination-bullet-active) {
  width: 12px;
  border-radius: 10px;
  background-color: #ff7649;
}
</style>
